import {consumeContext as _consumeContext} from "@Common/react/context";
import {Types}                             from "@Common/types";

export const consumeContext = _consumeContext as Types.Xpresso.Loaders.ConsumeContext;

